<template>
  <ion-app>
    <ion-content>
      <ion-grid>
        <div class="decorative-icon">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/menu.svg?alt=media&token=6cc87810-c0f8-41a0-a994-8ca4aa3813cf"
          />
        </div>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <ion-row>
          <ion-col size="12">
            <p class="top-title mt-0 mb-0 green text-xxl ion-text-uppercase">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
              />
              Meu perfil
            </p>
            <p class="mt-1 mb-0 dark text-sm thin">
              Olá,
              <span class="bold">{{ nameToShow }}</span>
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="profile-menu">
              <div class="avatar">
                <ion-avatar>
                  <ion-img v-if="profile.data.picture" :src="profile.data.picture"></ion-img>
                  <ion-img
                    v-else
                    src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/Updiet_Profile_Placeholder.png?alt=media&token=199883f5-c763-4265-90fa-b12a8839957e"
                  ></ion-img>
                </ion-avatar>
              </div>
              <div class="menu-items pt-5 pb-2 pr-2 pl-2">
                <div class="menu-items-list pl-2 pr-2">
                  <ion-item lines="none" class="cursor-pointer" @click="gotoSettings">
                    <ion-icon mode="ios" name="contact" slot="start"></ion-icon>
                    <ion-label>
                      <p class="mt-0 mb-0 bold dark text-sm">Minha conta</p>
                    </ion-label>
                    <ion-icon mode="ios" name="arrow-round-forward" slot="end"></ion-icon>
                  </ion-item>
                  <hr />
                  <ion-item lines="none" class="cursor-pointer" @click="gotoDishes">
                    <ion-icon mode="ios" name="heart" slot="start"></ion-icon>
                    <ion-label>
                      <p class="mt-0 mb-0 bold dark text-sm">Receitas favoritas</p>
                    </ion-label>
                    <ion-icon mode="ios" name="arrow-round-forward" slot="end"></ion-icon>
                  </ion-item>
                  <hr />
                  <ion-item lines="none" class="cursor-pointer" @click="gotoMyDiet">
                    <ion-icon mode="ios" name="grid" slot="start" color="primary"></ion-icon>
                    <ion-label>
                      <p class="mt-0 mb-0 green bold text-sm">Tabela da minha dieta</p>
                    </ion-label>
                  </ion-item>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div class="settings-item-top mt-4 mb-0 cursor-pointer" @click="gotoReportWeight">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold dark text-md">Balança</p>
            <p class="mt-0 mb-0 thin dark text-sm ion-text-wrap">Se pesou? Insira aqui o resultado</p>
          </ion-label>
          <ion-icon mode="ios" name="speedometer" slot="end" class="dark"></ion-icon>
        </ion-item>
      </div>
      <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoGoal">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold dark text-md">Objetivo e conquistas</p>
            <p
              class="mt-0 mb-0 thin dark text-sm ion-text-wrap"
            >Acompanhe seu progresso e edite o objetivo</p>
          </ion-label>
          <ion-icon mode="ios" name="navigate" slot="end" class="dark"></ion-icon>
        </ion-item>
      </div>
      <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoEditBody">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold dark text-md">Editar corpo</p>
            <p
              class="mt-0 mb-0 thin dark text-sm ion-text-wrap"
            >Edite as informações sobre seu corpo</p>
          </ion-label>
          <ion-icon mode="ios" name="body" slot="end" class="dark"></ion-icon>
        </ion-item>
      </div>
      <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoEditRestrictions">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold dark text-md">Editar alergias &amp; restrições</p>
            <p
              class="mt-0 mb-0 thin dark text-sm ion-text-wrap"
            >Altere as alergias e restrições da sua dieta</p>
          </ion-label>
          <ion-icon mode="ios" name="close-circle" slot="end" class="dark"></ion-icon>
        </ion-item>
      </div>
      <!--
      <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoEditPreferences">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold dark text-md">Editar preferências</p>
          </ion-label>
          <ion-icon mode="ios" name="arrow-round-forward" slot="end" class="dark"></ion-icon>
        </ion-item>
      </div>
      -->
      <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoEditDiet">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold dark text-md">Editar dieta</p>
            <p
              class="mt-0 mb-0 thin dark text-sm ion-text-wrap"
            >Altere o número e horário das suas refeições</p>
          </ion-label>
          <ion-icon mode="ios" name="nutrition" slot="end" class="dark"></ion-icon>
        </ion-item>
      </div>
      <div class="settings-item mt-o mb-0 cursor-pointer" @click="inviteFriend">
        <ion-item lines="none">
          <ion-label>
            <p class="mt-0 mb-0 bold green text-md">Convidar um amigo</p>
          </ion-label>
          <ion-icon mode="ios" name="flash" slot="end" class="green"></ion-icon>
        </ion-item>
      </div>
    </ion-content>
    <TabBar
      mealsClass="tab-grey"
      shoppingClass="tab-grey"
      profileClass="white tab-green"
      recipesClass="tab-grey"
    />
  </ion-app>
</template>

<script>
// capacitor
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;
const { Share } = Plugins;
// firebase
import db from "@/firebase/init";
// tab bar
import TabBar from "../../partials/structural/TabBar.vue";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "UserProfile",
  components: {
    TabBar
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      banner: {
        class: "banner-message-full p-3 d-none"
      },
      isLoading: true,
      fullPage: false,
      user: store.state.user,
      profile: store.state.profile,
      nameToShow: null
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    gotoSettings() {
      this.$router.push({
        name: "Settings"
      });
    },
    gotoReportWeight() {
      this.$router.push({
        name: "Report Weight"
      });
    },
    gotoDishes() {
      this.$router.push({
        name: "My Dishes"
      });
    },
    gotoSupport() {
      this.$router.push({
        name: "Support"
      });
    },
    gotoMyDiet() {
      this.$router.push({
        name: "My Diet"
      });
    },
    gotoGoal() {
      this.$router.push({
        name: "Goal"
      });
    },
    gotoEditBody() {
      this.$router.push({
        name: "Edit Body"
      });
    },
    gotoEditRestrictions() {
      this.$router.push({
        name: "Edit Restrictions"
      });
    },
    gotoEditPreferences() {
      this.$router.push({
        name: "Edit Preferences"
      });
    },
    gotoEditDiet() {
      this.$router.push({
        name: "Edit Diet"
      });
    },
    async inviteFriend() {
      const instance = this;
      const userId = instance.profile.id;
      await db
        .collection("users")
        .doc(userId)
        .update({
          milestoneInviteFriend: true
        });
      store.state.profile.data.milestoneInviteFriend = true;
      const info = await Device.getInfo();
      if (info.platform === "ios") {
        let shareRet = await Share.share({
          title: `Olha esse app incrível: Updiet`,
          text:
            "Plano de nutrição inteligente: + 1.500 receitas fáceis, saudáveis e deliciosas :)",
          url: `https://apps.apple.com/us/app/updiet/id1484349177?l=pt#?platform=iphone`,
          dialogTitle: "Compartilhe o Updiet com quem você ama"
        });
      } else if (info.platform === "android") {
        let shareRet = await Share.share({
          title: `Olha esse app incrível: Updiet`,
          text:
            "Plano de nutrição inteligente: + 1.500 receitas fáceis, saudáveis e deliciosas :)",
          url: `https://play.google.com/store/apps/details?id=com.updiet`,
          dialogTitle: "Compartilhe o Updiet com quem você ama"
        });
      } else {
        //
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      if (instance.profile.data.name) {
        const name = instance.profile.data.name;
        const firstName = name.replace(/ .*/, "");
        const surnameInitial = name.charAt(name.lastIndexOf(" ") + 1);
        instance.nameToShow = ` ${firstName} ${surnameInitial}.`;
        if (instance.profile.data.goal) {
          if (instance.profile.data.goal === "loseWeight") {
            instance.goalPT = "Emagrecimento";
          } else if (instance.profile.data.goal === "gainMuscles") {
            instance.goalPT = "Hipertrofia";
          } else if (instance.profile.data.goal === "stayHealthy") {
            instance.goalPT = "Equilíbrio";
          } else {
            //
          }
        }
      }
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}

ion-content {
  --padding-bottom: 5px !important;
  --background: transparent !important;
}

ion-app {
  max-height: 100vh !important;
  overflow-y: hidden !important;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: -1;
}

.background-image ion-img {
  height: 200px;
  width: 100%;
}

hr {
  border-bottom: 1px solid #eeeeee;
  width: 100%;
}

.profile-menu {
  position: relative;
  margin-top: calc(var(--standard-padding-top) + 20px);
  width: 100%;
  border-radius: 30px;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
}

.avatar {
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  width: 100%;
  justify-content: center;
}

ion-avatar {
  position: relative;
  height: 100px;
  width: 100px;
  border: 3px solid #f0f3f7;
  margin-top: 5vh;
}

.profile-loading {
  position: relative;
  height: 100px;
  width: 100px;
  margin-top: 5vh;
  border-radius: 50% !important;
  background: transparent !important;
}

.profile-title {
  padding-top: 80px;
  padding-bottom: 20px;
  text-align: center;
}

.menu-items-list {
  margin-bottom: 20px;
}

.settings-item-top ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}

.settings-item ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}

.settings-item-top {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}

.settings-item {
  border-bottom: 1px solid #eeeeee;
}
</style>